module.exports = __webpack_public_path__ + "files/742437ea0b2e234d37fb3f56e936b23e.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/places.png
// module id = 482
// module chunks = 60